<template>
  <section data-theme="dark" class="module careers">
    <div class="module-body">
      <table>
        <thead>
        <tr>
          <th>
            <button class="btn-strip" aria-label="Sort alphabetically" @click.stop.prevent="sortCareers('department')"
                    :class="{'is-selected': sortby == 'department'}">Department
            </button>
          </th>
          <th>
            <button class="btn-strip" aria-label="Sort alphabetically" @click.stop.prevent="sortCareers('name')"
                    :class="{'is-selected': sortby == 'name'}">Job title
            </button>
          </th>
          <th>
            <button class="btn-strip" aria-label="Sort alphabetically" @click.stop.prevent="sortCareers('location')"
                    :class="{'is-selected': sortby == 'location'}">Location
            </button>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="!dataLoaded">
          <td colspan="3">
            Loading spinner here.
          </td>
        </tr>
        <tr v-for="career in sortedCareers" :key="career.id" v-if="dataLoaded">
          <td>{{ (career.departments.length) ? career.departments[0].name : '' }}</td>
          <td><a :href="getCareerHref(career)">{{ career.title }}</a></td>
          <td>{{ career.location.name }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script setup>
import {ref, computed, onMounted} from 'vue'
import axios from 'axios'

const apiBaseUrl = 'https://boards-api.greenhouse.io/v1/boards/Vestmark/jobs?content=true'

const api = axios.create({
  baseURL: apiBaseUrl
})

const careers = ref([])
const sortby = ref('department')
const dataLoaded = ref(false)

const sortedCareers = computed(() => {
  const compare = (a, b) => {
    let aVal = ''
    let bVal = ''

    switch (sortby.value)
    {
      case 'department':
        aVal = a.departments[0].name
        bVal = b.departments[0].name
        break
      case 'name':
        aVal = a.title
        bVal = b.title
        break
      case 'location':
        aVal = a.location.name
        bVal = b.location.name
        break
    }

    if (aVal < bVal) return -1
    if (aVal > bVal) return 1
    return 0
  }

  return [...careers.value].sort(compare)
})

const getCareers = () => {
  api.get('')
      .then((response) => {
        dataLoaded.value = true
        careers.value = response.data.jobs
      })
}

const getCareerHref = (career) => {
  return '/careers/' + career.id
}

const getCareerTitleSlug = (career) => {
  return career.title.trim().replace(/-/g, ' ').replace(/[^\w\s]/g, '').replace(/\s\s+/g, ' ').toLowerCase().replace(/\s/g, '-')
}

const sortCareers = (by) => {
  sortby.value = by
}

onMounted(() => {
  getCareers()
})
</script>
